import i18next from 'i18next';
import React, { createContext, useContext, useMemo, useState } from 'react';

interface LanguageContextProps {
    language: string;
    changeLanguage: (lng: string) => void;
}

interface LanguageProviderProps {
    children: React.ReactNode;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider: any = ({ children }: LanguageProviderProps) => {
    const [language, setLanguage] = useState(i18next.language);

    const changeLanguage = (lng: string) => {
        i18next.changeLanguage(lng);
        setLanguage(lng);
    };

    const value = useMemo(() => ({ language, changeLanguage }), [language]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = (): LanguageContextProps => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};